import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";

priceStyles.productPrice = mergeToNew(priceStyles.productPrice, {
    price: {
        priceText: {
            size: 24,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 16,
                weight: "700",
                color: "text.accent",
            },
        },
    },
});
